export function isActivationEvent(event: KeyboardEvent) {
  return event.key === ' ' || event.key === 'Enter';
}
